import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import { AdminCoursePanel } from '../components/proshop/AdminCoursePanel';
import { useAdminAccess } from '../components/admin/AdminAccessProvider';
import { AdminAccessBoundary } from '../components/admin/AdminAccessGate';

export default function ProShopAdminPage() {
  const navigate = useNavigate();
  const { adminKey, adminEmail, logout } = useAdminAccess();
  return <AdminAccessBoundary entryPath="/proshop?mode=admin"><main className="min-h-screen bg-[var(--ps-bg-base)]" data-testid="proshop-admin-page">
    <nav className="course-workspace !pb-0 course-toolbar" aria-label="Pro Shop admin navigation">
      <Button variant="ghost" data-testid="admin-proshop-back-bookings" onClick={() => navigate('/book')}><ArrowLeft size={16} className="mr-2" />Bookings</Button>
      <Button variant="outline" data-testid="admin-proshop-dashboard" onClick={() => navigate('/admin?section=proshop')}><Shield size={16} className="mr-2" />Admin dashboard</Button>
      <Button variant="outline" data-testid="admin-proshop-logout" onClick={logout}>Sign out</Button>
      <p className="course-subtle w-full break-all" data-testid="admin-proshop-identity">{adminEmail}</p>
    </nav>
    <AdminCoursePanel adminKey={adminKey} />
  </main></AdminAccessBoundary>;
}